module.exports = __webpack_public_path__ + "img/g_qingdu.cca95415.png";